export const AlertTheme = {
    errorAlert: '#FF5252',
    warningAlert: '#FFBF00'
}

export const DefaultTheme = {
    primary: '#ce0f69',
    secondary: '#003473',
    accent: '#626d78',
    light: '#eeeeee',
    error: '#ed1c24',
    info: '#4b9bd4',
    success: '#7fa73d',
    warning: '#ffcb04',
    dark: '#555',
    white: '#ffffff',
    black: '#000000'
}
